
import { defineComponent } from 'vue'

import GenerateSCACheckoutURL from '~/apollo/mutations/owner/generateCheckoutUrlForSca.gql'

import type { FetchResult } from 'apollo-link'
import { BillingInterval, GenerateScaCheckoutUrlMutation, ScaProductPlan } from '~/types/types'

export default defineComponent({
  name: 'UpgradeScaPlanModal',
  props: {
    ownerId: {
      type: String,
      required: true
    }
  },
  data() {
    return { loading: false }
  },
  methods: {
    async handleSCAUpgrade() {
      this.loading = true
      try {
        const response: FetchResult<GenerateScaCheckoutUrlMutation> =
          await this.$applyGraphqlMutation(GenerateSCACheckoutURL, {
            ownerId: this.ownerId,
            plan: ScaProductPlan.PlanStarter,
            interval: BillingInterval.Monthly
          })

        const url = response.data?.getSubscriptionCheckoutUrlForSca?.url

        if (url) {
          window.location.href = url
        } else {
          throw new Error('invalid checkout url response from server')
        }
      } catch (error) {
        this.$logErrorAndToast(error as Error, 'We encountered an error. Please try again later.')
      }
      this.loading = false
    }
  }
})
